import {
  CalendarAddAlt,
  DeliveryParcel,
  Document,
  Information,
  SearchLocate,
} from "@carbon/icons-react";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

import OrderHeader from "../../components/orderHeader/OrderHeader";
import { useOrderContext } from "../../contexts/OrderContext";
import { useHeader } from "../../contexts/PageHeaderContext";
import { InboundDeliveryStatus } from "../../models/autogenerated-deliveryService-gql/graphql";
import { IStep } from "../../models/step";
import ProgressContent from "./screens/progressContent/ProgressContent";

export const newOrderSteps: IStep[] = [
  {
    number: 1,
    text: "enterInfo",
    icon: <Information size={24} />,
    done: false,
  },
  {
    number: 2,
    text: "enterItems",
    icon: <DeliveryParcel size={24} />,
    done: false,
  },
  {
    number: 3,
    text: "enterTimes",
    icon: <CalendarAddAlt size={24} />,
    done: false,
  },
  {
    number: 4,
    text: "addDocuments",
    icon: <Document size={24} />,
    done: false,
  },
  {
    number: 5,
    text: "confirmOrder",
    icon: <SearchLocate size={24} />,
    done: false,
  },
];

const NewOrder = () => {
  const { t } = useTranslation();
  const { savedProgress, progressLevel } = useOrderContext();
  const { updateHeader, updateSecondHeader } = useHeader();

  const updateHeaders = () => {
    updateHeader(<>{t("createNewOrder")}</>);
    updateSecondHeader(null);
  };

  useEffect(() => {
    updateHeaders();
  }, [t]);

  return (
    <div className="page-content">
      <Helmet title={t("createOrder")} />
      <OrderHeader
        paddingBottom="16px"
        amount={savedProgress.deliveryItems?.length || 1}
        //@ts-ignore
        status={progressLevel === 6 ? InboundDeliveryStatus.Created : "DRAFT"} //DRAFT is not a real status - but this will not provoke any errors.
      />
      <ProgressContent />
    </div>
  );
};

export default NewOrder;
